import { useMemo } from 'react';

import { regionDataToLocations } from 'helpers/locations';
import { useOpportunitiesActiveTab } from 'helpers/opportunities';
import { allLocations } from 'constants/regions';

export const useOpportunitiesLocations = ({ vendorRegionData, effectiveFilter }) => {
  const { tab: activeTab } = useOpportunitiesActiveTab();

  const vendorLocations = useMemo(
    () => regionDataToLocations(vendorRegionData ?? null),
    [vendorRegionData]
  );
  const vendorLocationsSet = useMemo(() => new Set(vendorLocations), [vendorLocations]);

  const [availableLocations, currentLocations] = useMemo(() => {
    const isValidVendorLocation = location => vendorLocationsSet.has(location);

    // If the user navigates to either the 'Following' or 'All' tabs and selects
    // locations outside of their vendor locations and then navigates
    // back to 'Recommended', this causes those locations to still appear in
    // the filter when they shouldn't. In that case, just reset the filter
    // back to the vendor locations and preserve any valid selections.
    if (activeTab === 'recommended') {
      return [
        allLocations.filter(isValidVendorLocation),
        effectiveFilter.locations.filter(isValidVendorLocation),
      ];
    }

    return [allLocations, effectiveFilter.locations];
  }, [activeTab, effectiveFilter.locations, vendorLocationsSet]);

  return {
    availableLocations,
    currentLocations,
  };
};
